<template>
    <window :size="size" :title="title">
        <div v-html="text"></div>
    </window>
</template>

<script>
export default {
    provide: {
        windowId: 'text'
    },
    props: {
        size: {
            type: String,
            default: 'lg'
        },
        title: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            required: true
        }
    }
}
</script>